import type { Config } from "../config.contract";
import { BaseEnvironment } from "./base.environment";

export class HmlEnvironment extends BaseEnvironment implements Config {
  /**
   * Webmotors base domain
   *
   */
  domain = "hportal.webmotors.com.br";

  /**
   * Enable logging for HML Environment
   *
   */
  logging = true;

  /**
   * Webmotors api URL
   *
   */
  apiURL = `https://${this.domain}/api`;

  /**
   * Webmotors private api URL
   *
   */
  apiPrivateURL =
    "https://yur5i9svf7-vpce-0f91c6824aa2e651d.execute-api.us-east-1.amazonaws.com/hml/api";

  /**
   * SEO private api URL
   *
   */
  seoApiPrivateURL =
    "https://sem3hlobfi-vpce-0f91c6824aa2e651d.execute-api.us-east-1.amazonaws.com/hml/api";

  /**
   * Webmotors base URL
   *
   */
  baseURL = `https://${this.domain}`;

  /**
   * Cookie domain on HML environment
   *
   */
  cookieDomain = [this.domain, `.${this.domain}`, ".webmotors.com.br"];

  /**
   * Auth Cookie Name on staging environment
   *
   */
  authCookieName = "webmotors.jwt.token.hk";

  /**
   * Access Token Cookie Name on staging environment
   *
   */
  accessTokenCookieName = "webmotors.access.token";

  /**
   * Refresh Token Cookie Name on staging environment
   *
   */
  refreshTokenCookieName = "webmotors.refresh.token.hk";

  /**
   * Vehicle photo path on HML environment
   *
   */
  photoPath = "https://himage.webmotors.com.br";

  /**
   * Webmotors chat api websocket URL
   *
   */
  chatApiUrl = "wss://hchat.webmotors.com.br";

  /**
   * Hot deal image path on HML environment
   *
   */
  hotDealImage = "https://image.webmotors.com.br/feiroes/imagens/hml/_portal/";

  /**
   * Data Dog Sample Config
   */
  traceSampleRate = 100;
  sessionSampleRate = 10;
  sessionReplaySampleRate = 10;

  /**
   * Seller shield image path
   */
  sellerShieldImage = "https://s3.amazonaws.com/webmotors/blindagem-fotos/hml/";

  /**
   * Login route
   *
   */
  loginRoute = `https://${this.domain}/login`;
}
